import {
  Divider,
  Drawer,
  DrawerOverlay,
  DrawerHeader,
  DrawerBody,
  DrawerContent,
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionButton,
  AccordionIcon,
  Icon,
  Box,
} from "@chakra-ui/react";
import {
  FiHome,
  FiLogIn,
  FiSettings,
  FiActivity,
  FiCheckCircle,
  FiDownload,
  FiTruck,
  FiXCircle,
  FiClipboard,
  FiImage,
  FiShoppingCart,
  FiDollarSign,
  FiTrendingUp,
  FiDatabase,
  FiLock,
  FiAward,
  FiSliders,
  FiBriefcase,
  FiBarChart2,
  FiLink,
  FiUsers,
} from "react-icons/fi";
import { useEffect, useState } from "react";
import { MdOutlineDashboard, MdOutlineRocketLaunch } from "react-icons/md";

import { BsBank, BsClockHistory, BsFillMoonStarsFill } from "react-icons/bs";
import { useAuth } from "../../contexts/AuthContext";
import useCalScheduling from "../../hooks/useCalScheduling";
import { canAccessNewFeatures } from "../../utils/featureAccess";
import { isExternalDemoUser } from "../../utils/demoAccess";
import { isWorkspacePreviewUser } from "../../pages/CRM/Workspace/workspaceAccess";
import DrawerItem from "./DrawerItem";
import NavButton from "./NavButton";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../utils/init-firebase";
import SubmissionDrawer from "../../pages/Loans/SubmissionDrawer";
import { installable, handleInstallClick } from "../../App";
import {
  FaBullhorn,
  FaFileInvoiceDollar,
  FaNewspaper,
  FaPoll,
  FaRegQuestionCircle,
  FaStoreAlt,
  FaTshirt,
} from "react-icons/fa";
import CreateRequest from "../Marketing/CreateRequest";
import { GrCompliance } from "react-icons/gr";
import { AiFillDashboard } from "react-icons/ai";
import { BiSolidPlanet } from "react-icons/bi";
import {
  FaChartLine,
  FaExclamationTriangle,
  FaTasks,
  FaUsers,
  FaStar,
  FaBrain,
} from "react-icons/fa";
import { FiCalendar, FiFileText, FiBell, FiMessageSquare, FiZap, FiSend } from "react-icons/fi";
import { GiStoneBlock } from "react-icons/gi";

export default function DrawerBar({ isOpen, onOpen, onClose }) {
  const { isAdmin, SuperAdmin, MarketingAdmin, currentUser, Roles } = useAuth();
  const [submissionsMenuIndex, setSubmissionsMenuIndex] = useState();
  const [marketingMenuIndex, setMarketingMenuIndex] = useState();
  const [eosMenuIndex, setEosMenuIndex] = useState();
  const [crmMenuIndex, setCrmMenuIndex] = useState();
  const [loading, setLoading] = useState(true);
  const [userRole, setUserRole] = useState(null);

  // Integrations page pilot gate: per-user scheduling flag or CRM admin
  const { enabled: calSchedulingEnabled } = useCalScheduling();
  const showIntegrationsNav =
    calSchedulingEnabled || SuperAdmin || Roles?.includes("CRM Admin");

  // External demo accounts (partner test drives) see ONLY the Origin CRM
  // accordion — every other Hub nav section is hidden. Strictly opt-in flag;
  // regular users are unaffected. See src/utils/demoAccess.js.
  const isExternalDemo = isExternalDemoUser(currentUser);

  useEffect(() => {
    const mmi = localStorage.getItem("marketingMenuIndex");
    if (mmi) {
      setMarketingMenuIndex(parseInt(mmi));
    }
    const smi = localStorage.getItem("submissionsMenuIndex");
    if (smi) {
      setSubmissionsMenuIndex(parseInt(smi));
    }
    const emi = localStorage.getItem("eosMenuIndex");
    if (emi) {
      setEosMenuIndex(parseInt(emi));
    }
    const cmi = localStorage.getItem("crmMenuIndex");
    if (cmi) {
      setCrmMenuIndex(parseInt(cmi));
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    localStorage.setItem("marketingMenuIndex", marketingMenuIndex);
  }, [marketingMenuIndex]);

  useEffect(() => {
    localStorage.setItem("submissionsMenuIndex", submissionsMenuIndex);
  }, [submissionsMenuIndex]);

  useEffect(() => {
    localStorage.setItem("eosMenuIndex", eosMenuIndex);
  }, [eosMenuIndex]);

  useEffect(() => {
    localStorage.setItem("crmMenuIndex", crmMenuIndex);
  }, [crmMenuIndex]);

  return (
    <Drawer
      onClose={onClose}
      autoFocus={false}
      returnFocusOnClose={false}
      onOverlayClick={onClose}
      onCloseComplete
      trapFocus
      closeOnEsc
      placement={"left"}
      isOpen={isOpen}
      size={"xs"}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerHeader>Future Home Loans</DrawerHeader>
        <DrawerBody m={0} p={0} display="flex" flexDir={"column"}>
          {!isExternalDemo && (
            <>
          <Divider />
          <DrawerItem onClose={onClose} icon={FiHome} name="Home" to="/" />
          <Divider />
          <DrawerItem
            onClose={onClose}
            icon={AiFillDashboard}
            name="My Dashboard"
            to="/my-dashboard"
          />
          <Divider />
          <DrawerItem
            onClose={onClose}
            icon={FiDollarSign}
            name="Comp Dashboard"
            to="/comp-dashboard"
          />
          <Divider />
          <DrawerItem
            onClose={onClose}
            icon={FiTrendingUp}
            name="Sales Dashboard"
            to="/sales-dashboard"
          />
          <Divider />
          <DrawerItem
            onClose={onClose}
            icon={FiAward}
            name="Sales Challenge"
            to="/sales-challenge"
          />
          <Divider />
          <DrawerItem
            onClose={onClose}
            icon={MdOutlineRocketLaunch}
            name="Ops Command Center"
            to="/ops-command-center"
          />
          <Divider />
          <Accordion
            w="100%"
            onChange={(index) => setSubmissionsMenuIndex(index)}
            allowToggle
            defaultIndex={submissionsMenuIndex}
          >
            <AccordionItem>
              <h2>
                <AccordionButton pt={"8%"} pb={"8%"} w="100%">
                  <Icon as={FaFileInvoiceDollar} />
                  <Box pl="2" textAlign="left">
                    Submissions
                  </Box>

                  <AccordionIcon alignSelf="flex-end" />
                </AccordionButton>
              </h2>
              <AccordionPanel p={0}>
                <Divider />
                <SubmissionDrawer
                  isFirstChild
                  isChild
                  action="Add"
                  isDrawerButton={true}
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={FiLogIn}
                  name="Setup Queue"
                  to="/setup-queue"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={BsClockHistory}
                  name="In Progress"
                  to="/in-progress"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={FiTruck}
                  name="Parked"
                  to="/parked"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={FaRegQuestionCircle}
                  name="TBD"
                  to="/tbd"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={FiCheckCircle}
                  name="Completed"
                  to="/completed"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  isLastChild={!isAdmin && !SuperAdmin ? true : false}
                  icon={FiXCircle}
                  name="Not Submitted"
                  to="/not-submitted"
                />
                {(isAdmin || SuperAdmin) && (
                  <>
                    <Divider />
                    {SuperAdmin && (
                      <>
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          icon={FiLock}
                          name="Lock Desk"
                          to="/lock-desk-reporting"
                        />
                        <Divider />
                      </>
                    )}
                    <DrawerItem
                      onClose={onClose}
                      isLastChild
                      isChild
                      icon={FiSettings}
                      name="Settings"
                      to="/submission-settings"
                    />
                  </>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
          <Accordion
            w="100%"
            onChange={(index) => setMarketingMenuIndex(index)}
            allowToggle
            defaultIndex={marketingMenuIndex}
          >
            <AccordionItem>
              <h2>
                <AccordionButton pt={"8%"} pb={"8%"} w="100%">
                  <Icon as={FaBullhorn} />
                  <Box pl="2" textAlign="left">
                    Marketing
                  </Box>
                  <AccordionIcon alignSelf="flex-end" />
                </AccordionButton>
              </h2>
              <AccordionPanel p={0}>
                <Divider />
                <CreateRequest
                  isFirstChild
                  isChild
                  action="Create"
                  isDrawerButton={true}
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={FiClipboard}
                  name="Requests"
                  to="/marketing-requests"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={FiShoppingCart}
                  name="Swag"
                  to="/swag"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={BiSolidPlanet}
                  name="Matrix"
                  to="/marketing-matrix"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isExternal
                  isChild
                  icon={BsBank}
                  name="Vault"
                  to="https://drive.google.com/drive/folders/1-l2aNJDhCJyc89HnHbeDt3xKxn4hkb4Z"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isExternal
                  isChild
                  icon={FaTshirt}
                  name="SquadLocker"
                  to="https://teamlocker.squadlocker.com/#/lockers/future-home-loans"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  icon={GrCompliance}
                  name="SM Compliance"
                  to="/social-media-compliance"
                />
                <Divider />
                <DrawerItem
                  onClose={onClose}
                  isChild
                  isLastChild={!SuperAdmin && !MarketingAdmin ? true : false}
                  icon={FiImage}
                  name="FHL Logos"
                  to="/logos"
                />

                {(MarketingAdmin || SuperAdmin) && (
                  <>
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaNewspaper}
                      name="Newsletters"
                      to="/monthly-newsletters"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaPoll}
                      name="Reports (beta)"
                      to="/marketing-reports"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiDatabase}
                      name="Dashboard"
                      to="/marketing-dashboard"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaStoreAlt}
                      name="Inventory"
                      to="/marketing-inventory"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isLastChild
                      isChild
                      icon={FiSettings}
                      name="Settings"
                      to="/marketing-settings"
                    />
                  </>
                )}
              </AccordionPanel>
            </AccordionItem>
          </Accordion>
            </>
          )}
          {/* --- EOS Menu --- */}
          {/* This block ONLY shows if the user has isEOSUser: true */}
          {currentUser?.isEOSUser === true && (
            <>
              <Divider />
              <Accordion
                w="100%"
                onChange={(index) => setEosMenuIndex(index)}
                allowToggle
                defaultIndex={eosMenuIndex}
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton pt={"8%"} pb={"8%"} w="100%">
                      <Icon as={AiFillDashboard} />
                      <Box pl="2" textAlign="left">
                        EOS
                      </Box>
                      <AccordionIcon alignSelf="flex-end" />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel p={0}>
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isFirstChild
                      isChild
                      icon={AiFillDashboard}
                      name="Dashboard"
                      to="/eos/dashboard"
                    />
                    <Divider />
                    {/* Rocks & Goals */}
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={GiStoneBlock}
                      name="Rocks"
                      to="/eos/rocks"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={MdOutlineRocketLaunch}
                      name="Rocks Dashboard"
                      to="/eos/rocks-dashboard"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={GiStoneBlock}
                      name="Historical Rocks"
                      to="/eos/historical-rocks"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaChartLine}
                      name="Scorecard"
                      to="/eos/scorecard"
                    />
                    <Divider />
                    {/* Tracking & Tasks */}
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaExclamationTriangle}
                      name="Issues"
                      to="/eos/issues"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaTasks}
                      name="Action Items"
                      to="/eos/action-items"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiCalendar}
                      name="Calendar"
                      to="/eos/calendar"
                    />
                    <Divider />
                    {/* Meetings */}
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaUsers}
                      name="L10 Meeting"
                      to="/eos/l10"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiFileText}
                      name="Meeting Summaries"
                      to="/eos/meeting-summaries"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiFileText}
                      name="Weekly Summary"
                      to="/eos/weekly-summary"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaStar}
                      name="Wins & Excited"
                      to="/eos/wins-excited"
                    />
                    <Divider />
                    {/* Communication */}
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiMessageSquare}
                      name="Messages"
                      to="/eos/messages"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiBell}
                      name="Notifications"
                      to="/eos/notifications"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaBrain}
                      name="Ideas"
                      to="/eos/ideas"
                    />
                    <Divider />
                    {/* Tools & Settings */}
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiFileText}
                      name="V/TO"
                      to="/eos/vto"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FaUsers}
                      name="Accountability Chart"
                      to="/eos/accountability-chart"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiCalendar}
                      name="Calendar Sync"
                      to="/eos/calendar-sync"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiFileText}
                      name="Policy Viewer"
                      to="/eos/policy-viewer"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiBell}
                      name="Preferences"
                      to="/eos/preferences"
                    />
                    {/* Admin (SuperAdmin only) */}
                    {SuperAdmin && (
                      <>
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          icon={FaBrain}
                          name="AI Usage"
                          to="/eos/ai-usage"
                        />
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          isLastChild
                          icon={FiSettings}
                          name="Admin"
                          to="/eos/admin"
                        />
                      </>
                    )}
                    {!SuperAdmin && <Divider />}
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </>
          )}
          {/* --- Origin CRM Menu --- */}
          {/* This block ONLY shows if the user has CRMUser: true or is SuperAdmin */}
          {(currentUser?.CRMUser === true || SuperAdmin) && (
            <>
              <Divider />
              <Accordion
                w="100%"
                onChange={(index) => setCrmMenuIndex(index)}
                allowToggle
                defaultIndex={crmMenuIndex}
              >
                <AccordionItem>
                  <h2>
                    <AccordionButton pt={"8%"} pb={"8%"} w="100%">
                      <Icon as={FiBriefcase} />
                      <Box pl="2" textAlign="left">
                        Origin CRM
                      </Box>
                      <AccordionIcon alignSelf="flex-end" />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel p={0}>
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isFirstChild
                      isChild
                      icon={MdOutlineDashboard}
                      name="Dashboard"
                      to="/crm/dashboard"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiBriefcase}
                      name="My Deals"
                      to="/crm/my-deals"
                    />
                    {/* Person Workspace PREVIEW — allowlisted user(s) + admins */}
                    {isWorkspacePreviewUser(currentUser, SuperAdmin) && (
                      <>
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          icon={FiUsers}
                          name="Workspace (Preview)"
                          to="/crm/workspace"
                        />
                      </>
                    )}
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiSend}
                      name="My Marketing"
                      to="/crm/my-marketing"
                    />
                    {canAccessNewFeatures({ currentUser, SuperAdmin }) && (
                      <>
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          icon={FiAward}
                          name="Leaderboard"
                          to="/crm/leaderboard"
                        />
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          icon={FiActivity}
                          name="Mortgage Monitor"
                          to="/crm/mortgage-monitor"
                        />
                      </>
                    )}
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiCalendar}
                      name="Calendar"
                      to="/crm/calendar"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiCheckCircle}
                      name="Tasks"
                      to="/tasks"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiBarChart2}
                      name="Analytics"
                      to="/crm/analytics"
                    />
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      icon={FiZap}
                      name="Campaigns"
                      to="/crm/campaigns"
                    />
                    {showIntegrationsNav && (
                      <>
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          icon={FiLink}
                          name="Integrations"
                          to="/crm/integrations"
                        />
                      </>
                    )}
                    <Divider />
                    <DrawerItem
                      onClose={onClose}
                      isChild
                      isLastChild={!(currentUser?.CRMRole === 'CRM Admin' || SuperAdmin)}
                      icon={FiSettings}
                      name="Settings"
                      to="/crm/settings"
                    />
                    {(currentUser?.CRMRole === 'CRM Admin' || SuperAdmin) && (
                      <>
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          icon={FiSliders}
                          name="Admin"
                          to="/crm/admin"
                        />
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          icon={FiDollarSign}
                          name="Usage"
                          to="/crm/usage"
                        />
                        <Divider />
                        <DrawerItem
                          onClose={onClose}
                          isChild
                          isLastChild
                          icon={FiMessageSquare}
                          name="Ideas/Feedback"
                          to="/crm/ideas"
                        />
                      </>
                    )}
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            </>
          )}
          {SuperAdmin == true ? (
            <>
              <Divider />
              <DrawerItem
                onClose={onClose}
                icon={FiSettings}
                name="Admin"
                to="/admin"
              />
              <Divider />
              <DrawerItem
                onClose={onClose}
                icon={FaPoll}
                name="Loan Reporting"
                to="/loan-reporting"
              />
            </>
          ) : null}
          {installable && (
            <>
              <Divider />
              <NavButton
                onOpen={handleInstallClick}
                name="Install App"
                label="Install App"
                icon={FiDownload}
              >
                Install App
              </NavButton>
            </>
          )}
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
